/**
 * @ngdoc overview
 * @name cbl.finanza.mf
 * @description Modulo funzionale dell'applicazione Consulenza
 */
(function() {
	"use strict";
	angular.module("cbl.finanza.mf", [
		'cbl.ssocore',
		'ui.grid',
		'ui.grid.autoResize',
		'ui.grid.cellNav',
		'ui.grid.edit',
		'ui.grid.exporter',
		'ui.grid.grouping',
		'ui.grid.pagination',
		'ui.grid.resizeColumns',
		'ui.grid.rowEdit',
		'ui.grid.selection',
		'ui.grid.treeView',
		'ui.router',
		'ui.select',
		'ngSanitize',
		'cbl.finanza.mf.directives',
		'cbl.common'
	]);
}())


/*****************
 ** WEBPACK FOOTER
 ** ./app/app.module.js
 ** module id = 1
 ** module chunks = 0 1
 **/